export default {
  PRINCIPAL: "校長",
  VICE_PRINCIPAL: "副校長",
  ASSISTANT_PRINCIPAL: "助理校長",
  DISCIPLINE: "輔導及訓導主任",
  SCH_AFFR_OFFICER: "課程發展主任/學務主任/教務主任",
  SUBJECT_PANEL: "學科主任",
  SUBJECT_TEACHER: "學科教師",
  IT_COORDINATOR: "資訊科技統籌主任/統籌員",
  LIBRARIAN: "圖書館主任/老師",
  CAREER: "升學及就業主任",
  CDP_COORDINATOR: "持續專業發展統籌主任 / 統籌員",
  OTHERS: "其他",
};
